up.compiler(".up_city_billing", function (element) {
  const selector = new Choices(element, {
    placeholder: true,
    placeholderValue: "Choisir...",
    removeItemButton: true,
    classNames: {
      containerOuter: ["choices", "w-80"],
      containerInner: [
        "choices__inner",
        "text-xs",
        "rounded-md",
        "border",
        "border-[#B3C1BA]",
        "bg-white",
        "px-1",
      ],
      input: ["choices__input"],
    },
  });

  return () => {
    selector.destroy();
  };
});
